import { TestQuotationLine } from './test-quotation-line.model';
import { PackageQuotationLine } from './package-quotation-line.model';

export class SubGroup {
    comlimsCode?: string;
    rushLevel?: number;
    code?: string;
    name?: string;
    comment?: string;
    sortIndex?: number;
    testQuotationLines?: TestQuotationLine[];
    packageQuotationLines?: PackageQuotationLine[];
    isFavorite?: boolean;
    isPartialFavorite?: boolean;
    isPartialSelected?: boolean;
    hideItem = false;
    executionNumber?:number;
}
